import { createGlobalStyles } from "goober/global";
import { firefoxOnly, styles } from "clutch/src/Style/style.mjs";

import { IS_APP } from "@/__main__/constants.mjs";
import router from "@/__main__/router.mjs";
import isRouteOverlay from "@/util/is-route-overlay.mjs";

export const style = (container: string) => `
${styles(container)}

@property --active-player-deg {
  syntax: '<angle>';
  inherits: false;
  initial-value: 0deg;
}

:root {
  /* this should match the "left-nav-width-collapsed" var but 1.5x */
  --toolbar-width: calc(var(--sp-1) * 18 * 3 / 2);
  --scrollbar-width: var(--sp-2_5);
  --scrollbar-width-sm: var(--sp-2_5);
  --page-tabs-height: var(--sp-13_5);
}

::-webkit-scrollbar {
  width: var(--scrollbar-width);
  height: var(--scrollbar-width);
}

::-webkit-scrollbar-thumb {
  background-color: var(--shade3-25);
  border-radius: 0;
  border: none;
}

::-webkit-scrollbar-thumb:hover {
  background-color: var(--shade3-50);
}

.disable-animations *,
.disable-animations *::before,
.disable-animations *::after {
  transition: none !important;
  animation: none !important;
}

/* ads misbehaving... */
img[width="1"][height="1"] { display: none; }

/* overwriting inmobi cmp styles */
#qc-cmp2-ui {
  max-width: unset !important;
}
#qc-cmp2-ui * {
  font-family: "Inter" !important;
}
body > #inmobi-injected-link {
  display: none;
}
#inmobi-injected-link a {
  font-size: var(--sp-3);
}

:where(${container}) {
  color: var(--shade0);
  background: ${
    !isRouteOverlay(router?.route?.currentPath)
      ? "var(--app-bg)"
      : "transparent"
  };
  overflow-x: hidden;
  ${IS_APP ? "cursor: default;" : ""}

  * { box-sizing: border-box; }

  ${firefoxOnly} {
    * {
      scrollbar-width: thin;
    }
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  textarea::-webkit-input-placeholder,
  input::-webkit-input-placeholder {
    color: var(--shade3);
  }

  [data-tooltip] * {
    pointer-events: none;
  }

  @keyframes invalid-link {
    from { color: var(--primary); }
    to { color: var(--blue); }
  }
}`;

export default (className: string) => {
  // Rewrite raw class name to selector.
  const container = `.${className}`;
  return createGlobalStyles`${style(container)}`;
};
